import { render, staticRenderFns } from "./WorkDataTable.vue?vue&type=template&id=08e2abaa&scoped=true"
import script from "./WorkDataTable.vue?vue&type=script&lang=js"
export * from "./WorkDataTable.vue?vue&type=script&lang=js"
import style0 from "./WorkDataTable.vue?vue&type=style&index=0&id=08e2abaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e2abaa",
  null
  
)

export default component.exports